<!-- src/views/Home.vue -->
<template>
  <div class="account-pages h-100 vh-100 d-flex align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="text-center mb-4">
            <a href="#" class="auth-logo mb-5 d-block">
              <img :src="require('@/assets/images/GRPRO_AXION_PRETA.svg')" alt="" height="100" class="logo logo-dark">
              <img :src="require('@/assets/images/GRPRO_AXION_BRANCA.svg')" alt="" height="100" class="logo logo-light">
            </a>
            <h4>Bem-vindo.</h4>
            <p class="text-muted mb-4">Preencha com suas credenciais para acessar</p>
          </div>

          <div class="card">
            <div class="card-body p-4">
              <form @submit.prevent="login()">

                <div class="mb-4">
                  <InputField 
                    type="email" 
                    label="E-mail *" 
                    placeHolder="Digite seu e-mail *"
                    :required="true"
                    icon="ri-mail-line" 
                    v-model="email" 
                  />
                </div>

                <div class="mb-4">
                  <InputField 
                    type="password" 
                    label="Senha *" 
                    placeHolder="Digite sua senha *"
                    :required="true"
                    icon="ri-lock-2-line" 
                    v-model="password" 
                  />
                </div>

                <div>
                  <ButtonField 
                    alignText="center"
                    text="Acessar" 
                    :widthMax="true" 
                    :submit="true"
                    type="success" 
                    size="default"
                    :isLoading="isLoadingLogin"
                    loadingText="Realizando Login"
                  />
                </div>

              </form>
            </div>
          </div>

          <div class="mt-5 text-center">
            <p>© Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api'
import { useAuthStore } from '@/stores/auth.js'
import { toast } from 'vue3-toastify'

export default {
  name: 'LoginPage',
  data(){
    return {
      password: '',
      email: '',
      authStore : useAuthStore(),
      isLoadingLogin: false
    }
  },
  methods: {
    async login(){

      this.isLoadingLogin = true
      const result = await api.post('/auth/login', { email: this.email, senha: this.password })

      if(result.data.access_token)
      {
        this.authStore.setToken(result.data.access_token)
        toast.success("Login realizado com sucesso")

        this.$router.push('/app')
      }else{
        toast.error("E-mail ou senha incorretos")
        this.isLoadingLogin = false
      }
      
    }
  },
  mounted() {
    if(this.authStore.access_token) this.$router.push('/app')
  },
}
</script>